<template>
    <div class="page-search show-results" id="page-search">
        <div class="page-search__top">
            <div class="container">
                <div class="wrapper">
                    <div id="search-filter" class="search-bar">
                        <div class="search-bar__icon"></div>
                        <input class="search" id="search-site" v-model="searchInput" name="s" type="text"
                               placeholder="Waar ben je naar op zoek?" autocomplete="off">
                        <div class="search-loader"></div>
                    </div>
                    <a class="close-search-form" id="close-search-form" href="#"></a>
                </div>
            </div>
        </div>

        <div class="page-search__results">
            <div class="container">
                <p class="results-for none" v-if="searchInput">Zoekresultaten voor <span id="search-term-display">'{{ searchInput }}'</span>
                </p>
                <div class="row search-cols">
                    <div :class="{ 'loader--loading' : loading }" class="loader"></div>
                    <template v-for="result in results" :key="result.id">
                        <div v-if="result.postResults.length" class="col-lg-4 col-md-6 search-col" :style="{ order: result.order }">
                            <div class="search-cols__item">
                                <div class="top">
                                    <h4>{{ result.name }}</h4>
                                    <div class="count">
                                        <span v-if="result.postResults.length > 10 && !result.showAllResults">10+</span>
                                        <span v-else>{{ result.postResults.length }}</span>
                                    </div>
                                </div>
                                <ul :class="{ toggle: result.showAllResults }">
                                    <li v-for="postResult in result.postResults" :key="postResult.id">
                                        <a :href="postResult.link" v-html="postResult.title.rendered"></a>
                                    </li>
                                </ul>
                                <div class="toggle-items" :class="{ toggled: result.showAllResults }" @click="result.showAllResults = !result.showAllResults" v-if="result.postResults.length > 10">{{result.showAllResults ? 'Bekijk minder resultaten' : 'Bekijk meer resultaten'}}</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {

        data() {
            return {
                searchInput: '',
                baseUrl: '',
                results: [],
                loading: false,
                timer: null,
                resultsLimit: 100,
            }
        },


        watch: {
            searchInput: function (value) {
                let _this = this;
                this.results = [];

                if (value.length > 2) {
                    _this.loading = true;
                    clearTimeout(_this.timer);
                    _this.timer = setTimeout(() => this.allSearchCalls(value), 200);
                }
            },

        },

        methods: {
            async getResults(post, title) {
                let fetchUrl = `${window.location.origin}/wp-json/wp/v2/${post}?search=${this.searchInput}&per_page=${this.resultsLimit}`;

                return axios.get(fetchUrl)
                    .then(response => {
                        // Set results to local data
                        let resultsObj = {
                            name: title,
                            postResults: response.data,
                            order: 1,
                            showAllResults: false
                        };

                        return resultsObj;
                    });
            },
            async allSearchCalls() {
                let queue = [];
                let _this = this;

                const postTypes = document.getElementById('search-component').getAttribute('data-post-types');
                const postTypesParsed = (postTypes) ? JSON.parse(postTypes) : [];

                await postTypesParsed.forEach((value, index) =>  {
                    queue.push(_this.getResults(value.type, value.title.replace('${quote}', '\'')));
                });

                if (queue) {
                    return Promise.all(queue)
                        .then(function (data) {
                            // Disable loading
                            if(_this.searchInput === '') {
                                return;
                            }
                            _this.results = data;
                        }).finally(function() {
                            _this.loading = false;
                        })
                }
            },

        },
    }
</script>